export default __webpack_public_path__ + "static/media/finger-snap.56ccb2e9.svg";